import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private userCred: any = null;
  rolePrevilages: any = []

  constructor() {
    const storedCreds = sessionStorage.getItem('userCreds');
    if (storedCreds) {
      this.userCred = JSON.parse(storedCreds);
      let rolePrevilages = this.userCred?.rolePrevilages || [];
      for(let list of rolePrevilages){
        let screens = list?.screenPrivilegeList || [];
        for(let screenPrivilegeList of screens){
          if (screenPrivilegeList?.name) {
            this.rolePrevilages.push(screenPrivilegeList.name);
          }
        }
      }
    }
    // this.rolePrevilages.push('telco-customer')
  }

  getCurrentUser() {
    return this.userCred;
  }

  canAccessRoute(route: string): boolean {


    if (route === '') {
      console.log('Empty route detected — allowing access to Dashboard');
      return true;
    }

    if (!this.userCred) return false;

    const allowedRoutes = this.rolePrevilages || [];

    console.log('Allowed routes from API:', allowedRoutes);
    console.log('Checking access for:', route);

    return allowedRoutes.includes(route);
  }
}
